import { createContext } from 'react';
import { UserContext } from '@/api/ApiTypes';

const UserContextProvider = createContext<UserContext|null>(null);
export default UserContextProvider;
